import React from 'react'
import { Platform, View } from 'react-native'
import Typography from '@ui/typography'
import { TypographyProps } from '@ui/typography/types'
import cn from '@ui/utils/cn'
import Gradient from '@ui/effects/Gradient'
import { colors } from '@ui/colors'
import Border from '@ui/effects/Border'
import { leadingNone } from '@ui/typography/styles'

interface Props {
  value?: string | React.ReactNode | number
  label?: string | React.ReactNode
  children?: React.ReactNode
  className?: string
  typographyProps?: TypographyProps
}

export default function DetailBlock({
  label,
  value,
  children,
  className,
}: Props) {
  const height = Platform.select({
    default: 176, // TODO: check it
    web: 242,
  })

  return (
    <View
      className={cn(
        'border-text/10 flex-1 items-center justify-center gap-2 overflow-hidden rounded-2xl',
        className
      )}
      style={{
        height,
        minHeight: height,
        maxHeight: height,
      }}
    >
      <Gradient
        colors={[colors.gray[100], colors.gray[75]]}
        start={[0, 0]}
        end={[1, 1]}
      />
      <Border />
      {value && (
        <Typography variant="H1" className={cn('font-head-bold', leadingNone)}>
          {value}
        </Typography>
      )}

      {label && (
        <Typography
          variant="SMB"
          className={cn(
            'color-text text-center uppercase tracking-wider',
            leadingNone
          )}
        >
          {label}
        </Typography>
      )}
      {children}
    </View>
  )
}
